import { createTheme, type Theme } from '@mui/material/styles';
import type { ThemeMode } from '@/types/common.types';
import { lightPalette, darkPalette } from './palette';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { components } from './components';

export { BRAND_COLORS } from './palette';

export function createAppTheme(mode: ThemeMode): Theme {
  return createTheme({
    palette: mode === 'dark' ? darkPalette : lightPalette,
    typography,
    breakpoints,
    shape: { borderRadius: 8 },
    components,
  });
}
